import React, { useState } from 'react';
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io';

const TailwindAccordion = ({ index, header, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen); // first open by default

  return (
    <div className="w-full mt-2 border-2 rounded-xl overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-3 flex justify-between items-center bg-body-backgroudColor rounded-t-xl border-b-2"
      >
        <div className="w-full text-left">{header}</div>
        <div className={`transform transition-transform duration-400`}>
          {isOpen ? <IoIosArrowDown size={18} /> : <IoIosArrowForward size={18} />}
        </div>
      </button>

      <div
        className={`transition-all duration-500 ease-in-out overflow-hidden ${
          isOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-body-backgroudColor">{children}</div>
      </div>
    </div>
  );
};

export default TailwindAccordion;
